export default __webpack_public_path__ + "static/upload-5afca83a34a2c99ac3bc1fafdfc60154.png";